import type { ReactNode } from "react";

export function Card({
  children,
  tone = "stone",
}: {
  children: ReactNode;
  tone?: "stone" | "emerald" | "amber" | "violet" | "sky";
}) {
  const tones = {
    stone:
      "border-stone-200 bg-white/70 dark:border-white/10 dark:bg-white/[0.03]",
    emerald:
      "border-emerald-200 bg-emerald-50/70 dark:border-emerald-900/60 dark:bg-emerald-950/20",
    amber:
      "border-amber-200 bg-amber-50/70 dark:border-amber-900/60 dark:bg-amber-950/20",
    violet:
      "border-violet-200 bg-violet-50/70 dark:border-violet-900/60 dark:bg-violet-950/20",
    sky: "border-sky-200 bg-sky-50/70 dark:border-sky-900/60 dark:bg-sky-950/20",
  };
  return (
    <div className={`rounded-2xl border p-3 ${tones[tone]}`}>{children}</div>
  );
}
